export const ONE_TO_ONE_EMAIL = 'oneToOneEmail';
export const CHANNEL_SWITCHING = 'channelSwitching';
export const GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS = 'gmailOutlookAndMicrosoftExchangeIntegrations';
export const EMAIL_TRACKING_AND_NOTIFICATIONS = 'emailTrackingAndNotifications';
export const ONE_TO_ONE_VIDEO_MESSAGING = 'oneToOneVideoMessaging';
export const MULTIPLE_EMAIL_SIGNATURES = 'multipleEmailSignatures';
export const EMAIL_TEMPLATES = 'emailTemplates';
export const SALES_CONTENT_ANALYTICS = 'salesContentAnalytics';
export const LIVE_CHAT = 'liveChat';
export const LOGGED_IN_VISITOR_IDENTIFICATION = 'loggedInVisitorIdentification';
export const DRAGGABLE_CHAT_WIDGET = 'draggableChatWidget';
export const CONVERSATIONAL_BOTS = 'conversationalBots';
export const TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS = 'ticketCreationLeadQualificationAndMeetingBookingBots';
export const CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING = 'customBotsCustomBranchingLogicAndAdvancedTargeting';
export const FACEBOOK_MESSENGER_INTEGRATION = 'facebookMessengerIntegration';
export const ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING = 'advancedMessengerBotBranchingAndAdvancedReporting';
export const CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS = 'codeSnippetsForCustomMessengerBotActions';
export const MEETING_SCHEDULER = 'meetingScheduler';
export const AI_MEETING_ASSISTANT = 'aiMeetingAssistant';
export const BOOK_ON_BEHALF_OF_OTHERS = 'bookOnBehalfOfOthers';
export const LEAD_FORM_ROUTING = 'leadFormRouting';
export const SHARED_INBOX = 'sharedInbox';
export const CONVERSATION_ROUTING = 'conversationRouting';
export const CUSTOM_VIEWS = 'customViews';
export const SNIPPETS = 'snippets';
export const TASKS = 'tasks';
export const TASK_CALENDAR_SYNC = 'taskCalendarSync';
export const REPEATING_TASKS_AND_QUEUES = 'repeatingTasksAndQueues';
export const CALLING = 'calling';
export const HUBSPOT_PROVIDED_PHONE_NUMBERS = 'hubspotProvidedPhoneNumbers';
export const INTERACTIVE_VOICE_RESPONSE = 'interactiveVoiceResponse';
export const BREEZE_PROSPECTING_AGENT = 'breezeProspectingAgent';
export const LINKEDIN_SALES_NAVIGATOR_INTEGRATION = 'linkedinSalesNavigatorIntegration';
export const SALES_WORKSPACE = 'salesWorkspace';
export const LEADS = 'leads';
export const GUIDED_ACTIONS = 'guidedActions';
export const SEQUENCES = 'sequences';
export const DYNAMIC_SEQUENCES = 'dynamicSequences';
export const TARGET_ACCOUNTS = 'targetAccounts';
export const ABM_TOOLS_AND_AUTOMATION = 'abmToolsAndAutomation';
export const TARGET_ACCOUNTS_OVERVIEW = 'targetAccountsOverview';
export const BREEZE_COPILOT = 'breezeCopilot';
export const DEALS = 'deals';
export const DEAL_PIPELINE_AUTOMATION = 'dealPipelineAutomation';
export const DEAL_TAGS = 'dealTags';
export const CUSTOM_DEAL_TAG_RULES = 'customDealTagRules';
export const DEAL_SUMMARIES = 'dealSummaries';
export const DEAL_SPLITS = 'dealSplits';
export const DEAL_APPROVALS = 'dealApprovals';
export const DOCUMENTS = 'documents';
export const HUBSPOT_MOBILE_APP = 'hubspotMobileApp';
export const MOBILE_INBOX = 'mobileInbox';
export const PAYMENTS = 'payments';
export const STRIPE_PAYMENT_PROCESSING = 'stripePaymentProcessing';
export const PAYMENT_LINKS = 'paymentLinks';
export const SUBSCRIPTIONS = 'subscriptions';
export const B2B_CHECKOUT = 'b2bCheckout';
export const QUOTES = 'quotes';
export const E_SIGNATURE = 'eSignature';
export const INVOICES = 'invoices';
export const REPORTING_DASHBOARDS = 'reportingDashboards';
export const SALES_ANALYTICS = 'salesAnalytics';
export const CUSTOM_REPORT_BUILDER = 'customReportBuilder';
export const DEAL_JOURNEY_ANALYTICS = 'dealJourneyAnalytics';
export const PRODUCTS = 'products';
export const GOALS = 'goals';
export const CUSTOM_GOALS = 'customGoals';
export const CONVERSATION_INTELLIGENCE = 'conversationIntelligence';
export const COACHING_PLAYLISTS = 'coachingPlaylists';
export const TRACKED_TERMS = 'trackedTerms';
export const FORECASTING = 'forecasting';
export const FORECAST_ACROSS_TEAM_HIERARCHIES = 'forecastAcrossTeamHierarchies';
export const AI_FORECASTING = 'aiForecasting';
export const PLAYBOOKS = 'playbooks';
export const EMBED_AND_UPDATE_PROPERTIES = 'embedAndUpdateProperties';
export const CUSTOM_PROPERTIES = 'customProperties';
export const CALCULATED_PROPERTIES = 'calculatedProperties';
export const SYNC_PROPERTIES = 'syncProperties';
export const SCORE_PROPERTIES = 'scoreProperties';
export const PREDICTIVE_LEAD_SCORING = 'predictiveLeadScoring';
export const FIELD_LEVEL_PERMISSIONS = 'fieldLevelPermissions';
export const DATA_MODEL = 'dataModel';
export const ASSOCIATION_LABELS = 'associationLabels';
export const CUSTOM_USER_PERMISSIONS = 'customUserPermissions';
export const PERMISSION_SETS = 'permissionSets';
export const CUSTOM_PERMISSION_SETS = 'customPermissionSets';
export const SLACK_INTEGRATION = 'slackIntegration';
export const USER_MANAGEMENT = 'userManagement';
export const TEAMS = 'teams';
export const PRESETS = 'presets';
export const ORGANIZE_TEAMS = 'organizeTeams';
export const LOG_IN_AS_ANOTHER_USER = 'logInAsAnotherUser';
export const SINGLE_SIGN_ON = 'singleSignOn';
export const ONE_TO_ONE_TECHNICAL_SUPPORT = 'oneToOneTechnicalSupport';
export const EMAIL_AND_IN_APP_CHAT = 'emailAndInAppChat';
export const PHONE_SUPPORT = 'phoneSupport';
export const LISTS = 'lists';
export const ADVANCED_LIST_CRITERIA = 'advancedListCriteria';
export const MULTIPLE_CURRENCIES = 'multipleCurrencies';
export const DUPLICATE_MANAGEMENT = 'duplicateManagement';
export const LINKEDIN_CRM_SYNC_INTEGRATION = 'linkedinCrmSyncIntegration';
export const SALES_EMAIL_FREQUENCY_CONTROLS = 'salesEmailFrequencyControls';
export const SALESFORCE_INTEGRATION = 'salesforceIntegration';
export const SALESFORCE_CUSTOM_OBJECT_SYNC = 'salesforceCustomObjectSync';
export const WORKFLOWS = 'workflows';
export const WORKFLOW_EXTENSIONS = 'workflowExtensions';
export const AUTOMATIC_LEAD_ROTATION = 'automaticLeadRotation';
export const TRIGGER_SEQUENCES = 'triggerSequences';
export const WORKFLOW_HEALTH_MONITORING = 'workflowHealthMonitoring';
export const CUSTOM_EVENTS = 'customEvents';
export const CUSTOM_OBJECTS = 'customObjects';
export const SENSITIVE_DATA = 'sensitiveData';
export const STANDARD_SANDBOX_ACCOUNT = 'standardSandboxAccount';